module.exports = __webpack_public_path__ + "img/menu_svea.752c679d.png";